import { themeUi } from '../../themeUi/themeUi';

export const pagesTitle = {
  color: themeUi.semantic.color.text.secondary950
};
